import { CardsRoutes as CardsRoutesEnum } from '../routes';
import Cards from '../hoc/cards/cards';
import CardsList from '../hoc/cards/list';
import CardInfo from '../hoc/cards/info';
import CardItem from '../hoc/cards/card-item';
import TransactionSidepanel from '../hoc/cards/transaction';
import OrderCard from '../hoc/cards/order';

const CardsRoutes = {
  path: CardsRoutesEnum.CARDS,
  element: <Cards />,
  children: [
    {
      path: CardsRoutesEnum.CARDS_LIST,
      element: <CardsList />,
      children: [
        {
          path: CardsRoutesEnum.CARDS_LIST_ORDER,
          element: <OrderCard />,
        },
      ],
    },
    {
      path: CardsRoutesEnum.CARD_INFO,
      element: <CardInfo />,
      children: [
        {
          path: CardsRoutesEnum.CARD_INFO_TRANSACTIONS,
          element: <CardItem />,
          children: [
            {
              path: CardsRoutesEnum.CARD_INFO_TRANSACTION_INFO,
              element: <TransactionSidepanel />,
            },
            {
              path: CardsRoutesEnum.CARD_ORDER,
              element: <OrderCard />,
            },
            {
              path: CardsRoutesEnum.CARD_EDIT,
              element: <OrderCard />,
            },
          ],
        },
      ],
    },
  ],
};

export default CardsRoutes;
